<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-orders-sidebar ref="handleOrdersSidebar" />
    <popup-order-preview ref="popupOrderPreview" />

    <vs-prompt
      @cancel="createPromptActive = false"
      @close="createPromptActive = false"
      @accept="createOrder"
      title="Create new order"
      accept-text="Create"
      :active.sync="createPromptActive"
    >
      <div>
        <div>
          Check below if you want the order to be automatically filled with
          suggested order lines
        </div>
        <vs-checkbox
          v-model="startWithSuggested"
          label="Start with suggested order lines"
          class="mt-4"
          color="primary"
        >
          Start with suggested order lines
        </vs-checkbox>
      </div>
    </vs-prompt>

    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="onClickCreateNew"
          type="relief"
          color="primary"
          class="mr-3"
          >New order</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        v-model="selected"
        pagination
        search
        max-items="8"
        :data="mappedOrders"
        @selected="onClicked(selected)"
      >
        <template slot="thead">
          <vs-th sort-key="stocktakeType">Type</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="orderLines">Order lines</vs-th>
          <!-- <vs-th sort-key="createdBy">Created by</vs-th> -->
          <vs-th sort-key="activatedBy">Placed by</vs-th>
          <vs-th sort-key="activatedAt">Placed at</vs-th>
          <vs-th sort-key="createdAt">Created at</vs-th>
          <vs-th>Actions</vs-th>
          <!-- <vs-th>Stock status</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="OrderIcon" />
                  <p class="ml-4">Order</p>
                </div>
              </vs-td>
              <vs-td>
                <div>
                  <vs-chip :color="stateMapping[tr.status].color">{{
                    tr.status
                  }}</vs-chip>
                </div>
              </vs-td>

              <vs-td>
                <div>
                  {{ tr.orderLines ? tr.orderLines.length + " line(s)" : "0" }}
                </div>
              </vs-td>

              <!-- <vs-td>
                <div v-if="tr.createdBy">
                  {{ tr.createdBy.username }}
                </div>
              </vs-td> -->

              <vs-td>
                <div v-if="tr.activatedBy">
                  {{ tr.activatedBy.username }}
                </div>
              </vs-td>

              <vs-td>
                <div class="flex" v-if="tr.activatedBy">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.activatedAt | formatDate }}
                </div>
              </vs-td>

              <vs-td>
                <div class="flex" v-if="tr.createdBy">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.createdAt | formatDate }}
                </div>
              </vs-td>

              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  @click.stop="onClicked(tr)"
                />
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="onClickPreview(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderIcon from "@/assets/images/order-icon.png";
import moment from "moment";
import HandleOrdersSidebar from "./HandleOrdersSidebar.vue";
import PopupOrderPreview from "./PopupOrderPreview.vue";

export default {
  components: {
    HandleOrdersSidebar,
    PopupOrderPreview,
  },
  data() {
    return {
      OrderIcon,

      selected: [],
      isLoading: true,
      currentPage: 1,
      pageSize: 10,

      //Create popup
      startWithSuggested: false,
      createPromptActive: false,
    };
  },
  methods: {
    onClickCreateNew() {
      this.createPromptActive = true;
    },

    async createOrder() {
      try {
        console.log("creating order");
        var response = await this.$store.dispatch("orders/createOrder", {
          venueId: this.activeVenueId,
          emptyOrder: !this.startWithSuggested,
        });

        this.$refs.handleOrdersSidebar.showOrder(response.id);

        await this.$store.dispatch("orders/getOrders", this.activeVenueId); // Refresh orders

        this.$vs.notify({
          title: "Order created",
          text: "A new draft order has been created.",
        });
        this.startWithSuggested = false;
        this.createPromptActive = false;
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to create order: ${err}`,
        });
        console.error(err);
      }
    },
    onClicked(selected) {
      this.$refs.handleOrdersSidebar.showOrder(selected.id);
    },
    onClickPreview(order) {
      this.$refs.popupOrderPreview.show(order);
    },
    // Check if date is valid using moment
    isValidDate(date) {
      if (!date) return false;
      return moment(date).year() > 1;
    },
  },
  computed: {
    ...mapGetters({
      activeVenueId: "venues/activeVenueId",
      orders: "orders/orders",
      stateMapping: "orders/stateMapping",
    }),
    mappedOrders() {
      return this.orders
        .slice()
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    },
  },

  async created() {
    this.isLoading = true;

    await this.$store.dispatch("orders/getOrders", this.activeVenueId);

    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
